import { render } from "./ActionListItemTransferTokens.vue?vue&type=template&id=e10b0df2"
import script from "./ActionListItemTransferTokens.vue?vue&type=script&lang=ts"
export * from "./ActionListItemTransferTokens.vue?vue&type=script&lang=ts"
script.render = render

export default script